import { nextTick } from "@tarojs/taro";
import _isFunction from "lodash/isFunction";
import { useEffect, useRef } from "react";
function useRenderedEffect(effect, deps) {
    const destructorRef = useRef();
    useEffect(() => {
        nextTick(() => {
            const destructor = effect?.();
            if (_isFunction(destructor)) {
                destructorRef.current = destructor;
            }
        });
        return destructorRef.current;
    }, deps);
}
export default useRenderedEffect;
